import React from "react";
import { useParams } from "react-router-dom";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { getBusById } from "../api/buses";

export default function BusDetail() {
  const { busId } = useParams();
  const bus = getBusById(busId);

  if (!bus) return <Typography>Bus not found</Typography>;

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card sx={{ minWidth: 300 }}>
        <CardContent>
          <Typography variant="h6">
            {bus.number} ({bus.route})
          </Typography>
          <Typography>
            Driver: {bus.driver.name}, {bus.driver.phone}
          </Typography>
          <Typography>
            Conductor: {bus.conductor.name}, {bus.conductor.phone}
          </Typography>
          <Typography>
            Last Location: {bus.lastLocation} ({bus.lastUpdated})
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

